import styled from "styled-components";

export const Container = styled.div`
    margin-left: 10px;
`;
